import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { createSlice } from '@reduxjs/toolkit';
import { name, FetchStudentStatis, } from '@store/statistics/service';
var Slice = createSlice({
    name: name,
    initialState: { data: {} },
    reducers: {},
    extraReducers: function (builder) {
        /** 发起查询学生统计请求 */
        builder
            .addCase(FetchStudentStatis.pending, function (state) {
            state.fetching = true;
            delete state.fetchingError;
        })
            .addCase(FetchStudentStatis.fulfilled, function (state, action) {
            state.fetching = false;
            state.data = action.payload;
        })
            .addCase(FetchStudentStatis.rejected, function (state, action) {
            state.fetching = false;
            state.fetchingError = action.error.message;
        });
    },
});
var stateSelector = createSelector(function (state) { return state; }, function (state) { return state.statistics; });
var statisticsSelector = createSelector(function (state) { return state; }, function (_state, type) { return type; }, function (state, type) {
    var result = state.data[type];
    var category = (result === null || result === void 0 ? void 0 : result.category) || [];
    /** 机构用户的统计数据 */
    if (type === 'organ-schooldepart') {
        var series_1 = ((result === null || result === void 0 ? void 0 : result.series) || []);
        return series_1.reduce(function (list, item) {
            return list.concat(item.data.map(function (value, index) {
                return {
                    label: category[index] || '',
                    group: item.schoolDepartName,
                    value: value,
                };
            }));
        }, []);
    }
    /** 学校用户的统计数据 */
    var series = ((result === null || result === void 0 ? void 0 : result.series) || []);
    return series.map(function (value, index) {
        return {
            label: category[index] || '',
            group: category[index] || '',
            value: value,
        };
    });
});
export var useStatisticsState = function () {
    return useSelector(stateSelector);
};
export var useStatus = function (action) {
    return useStatisticsState()[action];
};
export var useError = function (action) {
    var state = useStatisticsState();
    var error = null;
    switch (action) {
        case 'fetching':
            error = state.fetchingError;
            break;
        default:
            break;
    }
    return error;
};
export var useStatistics = function (parameter) {
    var state = useStatisticsState();
    var type;
    if (parameter.organID !== void 0) {
        type = 'organ-schooldepart';
    }
    else if (parameter.parentUnitID !== void 0) {
        type = 'unit-schooldepart';
    }
    else {
        return [];
    }
    return statisticsSelector(state, type);
};
export var reducer = Slice.reducer, actions = Slice.actions;
